import { useState } from "react";
import { Redirect, useHistory } from "react-router";
import axios from "axios";

import {
  Container,
  LogoImg,
  InputContainer,
  H1Login,
  ContainerInput,
  InputLogin,
  ContainerButtonLogin,
  ButtonLogin,
  ContainerButtonWeb,
  ImgWeb,
  SmallFooter,
} from "./style";

import { useUser } from "../../providers/UserContext";
import FacebookLogin from "@greatsumini/react-facebook-login";

const Login = () => {
  const history = useHistory();

  const [option, setOption] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("")
  const { user, Login } = useUser();

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  const getGoogleUrl = () => {
    const rootUrl = `https://accounts.google.com/o/oauth2/v2/auth`;

    const options = {
      redirect_uri: "http://localhost:3000/google/callback",
      client_id: "20723822831-94t73t76j95a8bf0b72tolv2jue7lnl6.apps.googleusercontent.com",
      access_type: "offline",
      response_type: "code",
      prompt: "consent",
      scope: [
        "https://www.googleapis.com/auth/userinfo.profile",
        "https://www.googleapis.com/auth/userinfo.email",
      ].join(" "),
      state: '/profile',
    };

    const qs = new URLSearchParams(options);

    return `${rootUrl}?${qs.toString()}`;
  }

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const data = {
      login: email,
      senha: password,
      tipo: option === false ? "Industria" : "Supermercado"
    }

    if (email && password) {

      api.post(
        "/login",
        data
      )
        .then(response => {
          Login(response.data);
          if (option === false) {
            history.push("/home")
          } else {
            history.push("/mapMaketplace")
          }
        })
        .catch(
          function (error) {

            console.log(Promise.reject(error))
            setError('Email ou senha incorretos!')
            return Promise.reject(error)

          }
        )
    } else {
      setError("Preencha todos os campos!")
    }


  };

  function handleOption() {

    setOption(!option);
  };

  if (user) {
    return <Redirect to={"/home"} />
  }

  return (
    <Container>
      <LogoImg src="./images/logohAsset 3.png" />
      <InputContainer>
        <H1Login>Login</H1Login>

        <ContainerInput onSubmit={handleOnSubmit}>
          <InputLogin
            type="email"
            name="email"
            autoComplete="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <InputLogin
            type="password"
            name="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <p>{error}</p>

          <ContainerButtonLogin>
            {option === false ? (
              <ButtonLogin type="submit">
                Entrar
              </ButtonLogin>
            ) : (
              <ButtonLogin type="submit">
                Entrar
              </ButtonLogin>
            )}

            <ButtonLogin onClick={() => history.push("/register")}>
              Cadastrar
            </ButtonLogin>
          </ContainerButtonLogin>


        </ContainerInput>
        {option === false ? (
          <ButtonLogin onClick={() => handleOption()}>industria</ButtonLogin>
        ) : (
          <ButtonLogin onClick={() => handleOption()}>mercado</ButtonLogin>
        )}
      </InputContainer>
      <ContainerButtonWeb>

        <a href={getGoogleUrl()}>
          <ImgWeb src="./images/button_gmail.svg" />
        </a>

        <FacebookLogin
          appId="615496626663551"
          onSuccess={(response) => {
            console.log('Login Success!', response);
          }}
          onFail={(error) => {
            console.log('Login Failed!', error);
          }}
          render={({ onClick, logout }) => (
            <a style={{
              cursor: 'pointer'
            }} onClick={onClick}>
              <ImgWeb src="./images/button_face.svg" />
            </a>
          )}
        />

      </ContainerButtonWeb>
      <SmallFooter>Powered by Mercadata Digital</SmallFooter>
    </Container>
  );
};
export default Login;
